import { UserRoleEnum } from '@core/enums/user_role_enum';
import { PARTNER_ADMIN_USER_ROLES, XEMEX_STAFF_ROLES } from './device-role-groups.constant';

/** Roles allowed to view and manually set a device's phase-count parameter (Settings tab).
 * Not the same allow-list as METER_ROLE_EDITOR_ROLES — that one excludes Mechanic, this includes
 * it. */
export const PHASE_COUNT_EDITOR_ROLES: string[] = [
  ...PARTNER_ADMIN_USER_ROLES,
  UserRoleEnum.Mechanic,
  ...XEMEX_STAFF_ROLES,
];
